// Key has to be in format "{text}:{text}: ..."
const getKeySubstring = (key: string, idx: number) => {
    const splitTag = key.split(":");
    if (idx > splitTag.length) return splitTag[splitTag.length - 1];
    if (idx < 0) return splitTag[0];
    return splitTag[idx];
};

export default getKeySubstring;
